import { ModelCommon } from './ModelCommon'
import { PersonType } from './Person'
import { OrganizationType } from './Organization'

type TeamType = {
  members: ((PersonType | OrganizationType) & { teamRole: string })[]
}

const typeName = 'Team'

export class Team extends ModelCommon implements TeamType {
  members: ((PersonType | OrganizationType) & { teamRole: string })[]

  constructor(ob: any) {
    super(ob.type || typeName, ob)
    this.members = ob.members ?? []
  }
}
